export const environment = {
  production: false,
  hmr: false,
  debug: false,
  client: 'Polaris-Boats',
  hostName: 'https://polarisboatsus-analytics-staging.azurewebsites.net',
  environmentName: 'staging',
  appName: 'Polaris Boats Analytics',
  ssoPassword: 'ShiftDigital#123',
  applicationInsights: {
    instrumentationKey: '06bd1698-d1a0-42f3-abd4-9e72f8ab1398'
  },
  defaultLocale: 'en',
  availableLocales: ['en'],
  timeZone: 'Eastern Standard Time',
  showLocaleSelector: 'true',
  numberOfMonthsToShowDefault: 12,
  numberOfQuartersToShowDefault: 8,
  defaultOrgLevelTypeIds: [1],
  closeRateLookbackMonths: 3,
  defaultChartColors: ['#1b365c', '#47ddfc', '#A6A6A6', '#D9D9D9', '#CCCCCC'],
  baseApiUri: 'https://polarisboatsus-analytics-api-staging.azurewebsites.net/api',
  authUri: 'https://polarisboatsus-analytics-api-staging.azurewebsites.net/token',
  baseV5ApiUri: 'https://polarisboats-analytics-apiv5-staging.azurewebsites.net/api',
  retailerToolsBaseUri: '',
  retailerToolsIncludeAuth: true,
  mysteryShopBaseUri: '',
  favIconPath: '/assets/icons/clients/polaris-boats/favicon.ico',
  loginRedirectUrl: '',
  logoutRedirectUrl: '',
  sidebarDefaultOpen: false,
  useV5WebsiteOverview: false,
  harmonyUrl: '',
  v5Reports: []
};
